<template>
	<header id="header" class="header" style="z-index:0">
		<div class="container">
			<div class="header__wrap">
				<div class="header__logo" @click="showExitIntent()">
					<img :src="logoPath() + '/templates/agila/images/logo.png'" alt="Agila Haustlerversicherung">
				</div>
				<div class="header__link">
					<span v-on:click="back(); pushDataLayer('ecommerce', 'go_back', 'zahlung')" id="backlink" class="back-link"><span class="back-link__icon icon-left-arrow"></span>Zurück</span>
				</div>
			</div>
		</div>
	</header>
</template>
<script>
import dialog from "../helpers/dialog";
import ExitIntent from "./Modal/ExitIntent.vue";

export default ({
  props: {
    registry: {
      type: Object,
      default() {
        return {}
      }},
    leadin: {
      type: Object,
      default() {
        return {}
      }},
    currentComponent: {
      type: String,
      default() {
        return ""
      }},
  },
	methods: {
      reload() {
        window.location.reload()
      },
      logoPath() {
        return process.env.VUE_APP_ENV_URL;
      },
    showExitIntent() {
        if (this.currentComponent == 'Checkout' || document.cookie.match('(^|;)\\s*seo_incentive_shown\\s*=\\s*([^;]+)') || this.leadin.brokerID != '1764575') {
          window.location.href = '/';
        } else {
          let d2 = new Date();
          d2.setTime(d2.getTime() + (7 * 24 * 60 * 60 * 1000));
          document.cookie = "seo_incentive_shown=1; expires=" + d2.toUTCString() + "; path=/";
          dialog.component(ExitIntent, undefined, undefined, undefined, 'no-padding').then(result => {
            if (result) {
              let d2 = new Date();
              d2.setTime(d2.getTime() + (7 * 24 * 60 * 60 * 1000));
              document.cookie = "seo_incentive=1; expires=" + d2.toUTCString() + "; path=/";
            }
          });
        }
    },
    back() {
      let where = {1: 'tier', 2: 'persoenliche-daten', 3: 'gesundheit', 4: 'zahlung'};
      if (this.isHPS(this.leadin)) {
        where = {1: 'tier', 2: 'persoenliche-daten', 3: 'zahlung'};
      }
      let backPlace = 1;
      if (this.currentComponent == 'Health') {
        backPlace = 2;
      } else if (this.currentComponent == 'Payment') {
        backPlace = this.isHPS(this.leadin) ? 2 : 3;
      } else if (this.currentComponent == 'Pet') {
        const urls = ['/versicherungen/tierkrankenschutz-tarife', '/versicherungen/op-kostenschutz-tarife', '/versicherungen/haftpflichtschutz-tarife']
        const productIDs = {'1': 0, '2': 0, '3': 1, '4': 0, '5': 2, '6': 2, '7': 2, '11': 1, '12': 1, '15': 2, '16': 2}
        window.location.href = urls[productIDs[this.leadin.productActive]];
      }
      this.$parent.back(backPlace, where[backPlace])
    }
	}
})
</script>


